/**
 * @param {import('../../../../type-definitions').SortingOptions} sortingOptions - sorting options
 * @returns {string} mobile sorting form HTML
 */
export default sortingOptions => `
    <form id="sortingform" class="hide-on-desktop" action="" method="post" name="Product-Sorting-Options">
        <fieldset>
            <div class="sort-by-inner">
                <div class="select-title">
                    <span class="icon icon-sort" aria-hidden="true"></span>
                    <div class="select-text">
                        ${window.Resources.SORT}
                    </div>
                </div>
                <select id="grid-sort-header" class="loading-element" aria-describedby="grid-sort-header-text"
                    ${!sortingOptions.selectedOption ? 'style="font-style:italic;"' : ''}
                    aria-label="${window.Resources.SEARCH_SORT_HIDDEN_LABEL}">
                    ${
                        !sortingOptions.selectedOption
                            ? `
                                <option style="font-style:italic" value="" disabled selected>
                                    ${window.Resources.SEARCH_UNDEFINED_SORTING_RULE}
                                </option>
                            `
                            : ''
                    }
                    ${sortingOptions.options
                        .map(
                            option => `
                                <option data-sort-id="${option.id}" data-value="${option.order}"
                                    ${option.selected ? 'selected disabled' : ''}>
                                    ${option.name}
                                </option>
                            `
                        )
                        .join('')}
                </select>
            </div>
        </fieldset>
    </form>
`;
